import PageHeader from 'shared/components/page-header/page-header';
import SharedButton from 'shared/components/buttons/button';
import { useDialog } from 'core/providers/DialogProvider';
import { useDocument } from 'core/hooks/useDocument';
import { ILogisticsMetaDao } from 'core/api/types/meta.interface';
import { AddEditLogisticsMetaDialog } from './add-edit-logistics-meta-dialog';
import { useSharedData } from 'core/providers/SharedDataProvider';
import EditLocationStatusDialog from '../pharmacy-settings/edit-location-status-dialog';
import Toggle from '@atlaskit/toggle';
import { showErrorFlag, showSuccessFlag } from 'core/utilities/flags-helper';
import { useFlags } from '@atlaskit/flag';
import MetaApiService from 'core/api/meta/meta-api.service';
import { MetaApiService as MetaApiServiceNew } from 'core/api';

const SettingsOverview = () => {
  const dialog = useDialog();

  const { data: logisticsMeta } = useDocument<ILogisticsMetaDao>({
    apiService: MetaApiServiceNew,
    uid: 'logistics',
  });
  const { deliveryMeta: meta } = useSharedData();
  const flags = useFlags();

  const updateLocationStatus = async (key: string, enabled: boolean) => {
    try {
      const locationStatusValue = meta?.locationStatus?.map((status) =>
        status.key !== key ? status : { ...status, active: enabled }
      );

      await MetaApiService.update('deliveries', {
        locationStatus: locationStatusValue,
      });
      showSuccessFlag('Update successful', 'The setting was successfully updated.', flags);
    } catch (error) {
      console.log(error);
      showErrorFlag('An error occurred', 'Settings could not be updated, please try again.', flags);
    }
  };

  return (
    <>
      <PageHeader title='System settings' />
      <div className='grid grid-cols-1 gap-6 mt-6 h-max'>
        <div className='bg-white w-full rounded-md shadow-md h-fit'>
          <div className='flex items-center p-4 border-b justify-between'>
            <p className='headline-05'>Alert Radius</p>
            <SharedButton
              onClick={() => dialog?.openDialog(<AddEditLogisticsMetaDialog logisticsMeta={logisticsMeta} />)}
              type='button'
              appearance='primary'
              label='Edit'
            />
          </div>
        </div>
        <div className='bg-white w-full rounded-md shadow-md h-fit'>
          <div className='flex items-center p-4 border-b justify-between'>
            <p className='headline-05'>Location status</p>
            <SharedButton
              onClick={() => dialog?.openDialog(<EditLocationStatusDialog status={meta?.locationStatus ?? []} />)}
              type='button'
              appearance='primary'
              label='Edit'
            />
          </div>
          {meta?.locationStatus?.map((status) => (
            <div key={status.key} className='flex justify-between items-center border-b last:border-0 p-4'>
              <p>{status.name}</p>
              <Toggle
                size='large'
                onChange={() => updateLocationStatus(status.key, !status.active)}
                isChecked={status.active}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SettingsOverview;
